import RightRobotCard from '../cards/new/common/RightRobotCard'
import useWindowSize from 'components/util/useWindowSize'

const audience = [
  {
    label: 'Trades',
    copy: 'Builders, plumbers, and electricians managing quotes and client updates.',
  },
  {
    label: 'Appointments',
    copy: 'Therapists, beauticians and hairdressers managing bookings and reminders.',
  },
  {
    label: 'Small Businesses',
    copy: 'Keep professional and personal chats separate.',
  },
  {
    label: 'Teams',
    copy: 'Assign different business numbers to team members for clear ownership.',
  },
]

const WhoIsW4BFor = () => {
  const size = useWindowSize()

  return (
    <RightRobotCard
      image={{
        alt: 'Robot holding a phone with WhatsApp logo',
        desktop: {
          src: '/images/new/whatsapp/robot-holding-whatsapp.png',
          dimensions: {
            width: 657,
            height: 734,
          },
        },
        mobile: {
          src: '/images/new/whatsapp/robot-holding-whatsapp.png',
          dimensions: {
            width: 657,
            height: 734,
          },
        },
      }}
      imageContainerWidth={size.isLgOrHigher ? '45%' : '100%'}
      imageStyle={{
        objectFit: 'contain',
        maxWidth: '100%',
        height: '100%',
      }}
    >
      <div className='d-flex flex-column flex-1 px-4 pt-8 py-lg-20 ps-lg-15 me-lg-n18 me-xxl-n47'>
        <h2 className='fs-fluid-36-48 lh-108 lh-lg-105 fw-semibold mb-5'>
          Who is WhatsApp for <br className='d-none d-lg-block' /> Business
          designed for?
        </h2>
        <p className='fs-fluid-18-24 fw-semibold lh-114 mb-6'>
          WhatsApp for Business is perfect for any company that wants simpler,
          faster communication with its customers, from freelancers to SMEs.
        </p>
        <div className='d-flex flex-column gap-5'>
          {audience.map((item) => (
            <div className='fs-fluid-18-22 fw-semibold lh-114' key={item.label}>
              <span className='fw-bold'>{item.label}: </span>
              <span className='color-grey5'>{item.copy}</span>
            </div>
          ))}
        </div>
      </div>
    </RightRobotCard>
  )
}

export default WhoIsW4BFor
